import { getQueryParamsForScrollAndFocus } from '@/components/ux/hooks/use-scroll-and-focus';
import type { Comment } from '@/models/registry';
import type { Trade } from '@/models/types';

export const useGetTradeCommentUrl = (
  tradeShortId: Trade['short_id'],
  comment: Comment,
) => {
  // For trade comments, we'll create a URL that navigates to the trade appraisal
  // with query params to scroll to the specific comment
  const queryParams = getQueryParamsForScrollAndFocus({
    uiType: 'comment',
    id: comment.id,
  });

  // Construct the URL to the trade appraisal page
  const pathname = `/trade/${tradeShortId}/`;
  const searchParams = new URLSearchParams(queryParams);
  const url = `${pathname}?${searchParams.toString()}`;

  return `${window.location.origin}${url}`;
};
